import { render } from "./VipModal.vue?vue&type=template&id=cfd16fa6&scoped=true"
import script from "./VipModal.vue?vue&type=script&lang=js"
export * from "./VipModal.vue?vue&type=script&lang=js"

import "./VipModal.vue?vue&type=style&index=0&id=cfd16fa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd16fa6"]])

export default __exports__